module.exports = __webpack_public_path__ + "images/store_case_study/ucs-pic2_287341e6ae54703adfe1b1cdae61373c.png";